import {createAction, props} from '@ngrx/store';
import {Rental} from '@automata/models/rental';
import {RentalSettings} from '@automata/interfaces/rental-settings';

export const LoadRentals = createAction('[Rentals] Load Start');
export const LoadRentalsComplete = createAction('[Rentals] Load Complete', props<{rentals: Rental[]}>());

export const UpdateRentalSettings = createAction('[Rentals] Update Settings', props<{settings: RentalSettings, rental: Rental}>());
export const UpdateRentalSettingsComplete = createAction('[Rentals] Update Settings Complete', props<{rental: Rental}>());
